/**
 * Global tick state — symbol -> last tick.
 *
 * Component'ler `subscribe()` ile dinler, gateway tick'i geldiğinde
 * `update()` çağrılır ve tüm subscriber'lar tetiklenir.
 *
 * Lit @state ile entegre: component connectedCallback subscribe,
 * disconnectedCallback unsubscribe. Memory leak guard.
 */

export interface TickLike {
    symbol: string;
    bid?: string;
    ask?: string;
    mid?: string;
    server_ts?: number;
    [k: string]: unknown;
}

type Listener = (symbol: string, tick: TickLike) => void;

class TickStore {
    private ticks = new Map<string, TickLike>();
    private listeners = new Set<Listener>();

    update(symbol: string, tick: TickLike): void {
        // Monotonic guard (O13): reconnect/replay sırasında gecikmiş daha ESKİ bir tick
        // taze tick'i ezip fiyatı geriye sıçratmasın. server_ts varsa karşılaştır; yoksa
        // (eski yol) koşulsuz uygula. Eşit/yenisi kabul edilir.
        const prev = this.ticks.get(symbol);
        if (
            prev?.server_ts !== undefined &&
            tick.server_ts !== undefined &&
            tick.server_ts < prev.server_ts
        ) {
            return;
        }
        this.ticks.set(symbol, tick);
        for (const l of this.listeners) {
            l(symbol, tick);
        }
    }

    get(symbol: string): TickLike | undefined {
        return this.ticks.get(symbol);
    }

    subscribe(listener: Listener): () => void {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }

    clear(): void {
        this.ticks.clear();
    }

    size(): number {
        return this.ticks.size;
    }

    /** Tüm sembollerin server_ts değerleri — global staleness hesabı için. */
    allServerTimestamps(): Array<number | undefined> {
        const out: Array<number | undefined> = [];
        for (const tick of this.ticks.values()) {
            out.push(tick.server_ts);
        }
        return out;
    }
}

export const tickStore = new TickStore();
